import { Link } from "react-router-dom";
const Footer = () => {
  const openFacebook = () => {
    window.open("https://www.facebook.com/CheckoffFinance", "_blank");
  };
  const openInstagram = () => {
    window.open(
      "https://instagram.com/checkoff.finance?igshid=NzNkNDdiOGI=",
      "_blank",
    );
  };
  const openWhatsapp = () => {
    window.open("https://wa.me/message/AAU5TDSUAWEWI1", "_blank");
  };
  return (
    <div className="footer">
      <div className="footer-data">
        <div className="social-media-container">
          <img
            className="footer-logo-container"
            src={`${process.env.PUBLIC_URL}/assets/icons/checkoff-logo-down.svg`}
            alt="checkoff-logo"
          />
        </div>

        <div className="services">
          <h2 className="services-title">Product</h2>
          <div className="services-text">
            <Link to="/" className="services-link">
              <p>Loans</p>
            </Link>
            <Link to="/wealth-management" className="services-link">
              <p>Wealth Management</p>
            </Link>
            <Link to="/solar-financing" className="services-link">
              <p>Solar Financing</p>
            </Link>
            <Link to="/bankvole" className="services-link">
              <p>Bankvole</p>
            </Link>
          </div>
        </div>

        <div className="services">
          <h2 className="services-title">Company</h2>
          <div className="services-text">
            <Link to="/about-us" className="phone-link">
              <p>About Us</p>
            </Link>
            <Link to="/legal/privacy-policy" className="phone-link">
              <p>Privacy Policy</p>
            </Link>
            <Link to="/legal/ims-policy" className="phone-link">
              <p>IMS Policy</p>
            </Link>

            <Link to="/legal/whistleblower" className="phone-link">
              <p>Whistleblower Statement</p>
            </Link>
            <Link to="/legal/terms-and-condition" className="phone-link">
              <p>Terms & Condition</p>
            </Link>
            <Link to="/bankvole-faqs" className="phone-link">
              <p>Bankvole FAQs</p>
            </Link>
          </div>
        </div>

        <div className="services">
          <h2 className="services-title">Contact Us</h2>
          <div className="services-text">
            <p>
              <a
                href="mailto:customerservice@checkoff.loans"
                className="phone-link"
              >
                customerservice@checkoff.loans
              </a>
            </p>
            <p>
              <a className="phone-link" href="tel:018899900">
                018899900
              </a>
            </p>
            <p>
              <a className="phone-link" href="https://wa.me/2348172705123">
                +234 81727 05123
              </a>
            </p>
            <p>
              <a className="phone-link" href="https://wa.me/2349082600487">
                +234 90826 00487
              </a>
            </p>
            <button
              onClick={openFacebook}
              style={{ marginLeft: "-10px" }}
              className="btn border-0"
            >
              <img
                src={`${process.env.PUBLIC_URL}/assets/icons/facebook-bottom.svg`}
                alt="facebook-logo"
              />
            </button>
            <button onClick={openInstagram} className="btn border-0">
              <img
                src={`${process.env.PUBLIC_URL}/assets/icons/instagram-bottom.svg`}
                alt="instagram-logo"
              />{" "}
            </button>
            <button onClick={openWhatsapp} className="btn border-0">
              <img
                src={`${process.env.PUBLIC_URL}/assets/icons/whatsapp-bottom.svg`}
                alt="whatsapp-logo"
              />
            </button>
          </div>
        </div>
      </div>
      <div className="cbn-data">
        <div className="cbn-container">
          <div>
            <img
              className="cbn-img"
              src={`${process.env.PUBLIC_URL}/assets/img/central-bank-logo.svg`}
              alt="cbn"
            />{" "}
            Checkoff Finance Company Ltd is regulated by the Central Bank of
            Nigeria (CBN)
          </div>
        </div>
      </div>
      <div className="cbn-data">
        <div className="cbn-container">
          <div>
            <img
              style={{ width: "5rem", height: "4rem" }}
              className="cbn-img"
              src={`${process.env.PUBLIC_URL}/assets/img/ndpr.png`}
              alt="cbn"
            />{" "}
            Checkoff Finance Company Ltd is NDPR COMPLIANT
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
